import React, { Fragment, Component } from "react";
import Layout from "./Common/Layout";
import Error404 from "./Common/Layout/Error404";
import NotAuthorized from "./Common/Layout/NotAuthorized";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Categories from "./Pages/Categories";
import BulkEditPageLayout from "./Pages/Users/bulkEdit";
import CreateUser from './Pages/Users/Create_User/CreateUser';
import StaffReportLayout from "./Pages/StaffLinking/StaffLinkingIndex";
import Locations from "./Pages/Locations";
import IntegrationDashboard from "./Pages/IntegrationDashboard/Dashboard"
import TaxTaskToBeLinkedIndex from "./Pages/ManageTaxReturns/TaxTaskToBeLinkedIndex"
//import { NotificationStack } from './Common/Notification';

import { Notify, NOTIFICATIONS_POS_BOT_RIGHT } from 'react-redux-notify';
import { connect } from "react-redux";
import * as types from "./Constants/actionTypes";
import CallbackPage from "./Pages/callbackpage";
import { history } from "./Store/index";
import { ConnectedRouter } from "connected-react-router";
import CustomFieldPage from "../src/Pages/CustomFields/index";
import Clients from "./Pages/Clients";
import IntegrationForm from "./Pages/CCHiFirm/IntegrationForm";



class App extends Component {
    constructor(props) {
        super(props);
        // this.state = {
        //   notifications: [],
        //   count: 0,
        // }
    }

    // componentWillReceiveProps(nextProps) {
    //   if (nextProps.notification.id !== this.props.notification.id) {
    //     this.addNotification(nextProps.notification);
    //   }
    // }

    // inArray(arr, item) {
    //   return arr.find((el) => el.key === item.id)
    // }

    // addNotification(data) {
    //   const { notifications } = this.state;
    //   //const id = notifications.length;
    //   //const newCount = count + 1;
    //   if (this.inArray(notifications, data)) {
    //     return;
    //   }
    //   if (data.action === 'dismiss') {
    //     notifications.push({
    //       message: data.msg,
    //       key: data.id,
    //       action: 'Dismiss',
    //       dismissAfter: 4000,
    //       onClick: this.removeNotification.bind(this, data.id),
    //     });

    //   }

    //   if (data.action === 'retry') {
    //     notifications.push({
    //       message: data.msg,
    //       key: data.id,
    //       action: 'Retry',
    //       dismissAfter: false,
    //       onClick: this.retryFailedAction.bind(this, data),
    //     });
    //   }

    //   const newNotification = notifications;

    //   this.setState({
    //     notifications: newNotification,
    //   });
    // }

    // removeNotification(count) {
    //   const { notifications } = this.state;
    //   this.setState({
    //     notifications: notifications.filter(n => n.key !== count)
    //   });
    // }

    // // retryFailedAction(data) {

    // //   switch (data.type) {
    // //     case types.UPDATE_TASK_INSTRUCTIONS:
    // //       this.removeNotification(data.id);
    // //       this.props.actions.updateTaskInstructions(data.additionalRetryData.taskIds, data.additionalRetryData.ins);
    // //       break;
    // //     default:
    // //       break;
    // //   }

    // // }

    // onClick() {
    //   this.addNotification();
    // }

    // onDismiss(notification) {

    //   let item = this.state.notifications.indexOf(notification);
    //   let arr = this.state.notifications;
    //   arr.splice(item, 1);
    //   this.setState({
    //     notifications: arr,
    //   });

    // }

    render() {
        let notifyDefaultProps = {
            position: NOTIFICATIONS_POS_BOT_RIGHT,

        };
        return (
            <Fragment>
                <ConnectedRouter history={history}>
                    <Switch>
                        <Route path="/cchifirmsettings" component={IntegrationForm} />    
                        <Route path="/edituser/:id/edit" exact component={CreateUser} />
                        <Route path="/callback" component={CallbackPage} />
                        <Route path="/bulkedit" component={() => <BulkEditPageLayout />} />
                        <Route path="/createuser" exact component={CreateUser} />
                        <Route path="/taxintegrated" component ={TaxTaskToBeLinkedIndex}/>
                        <Route exact path="/" component={() => <Layout />} />
                        <Route path="/stafflinkingindex" exact component={StaffReportLayout} />
                        <Route path="/integrationDashboard" exact component={IntegrationDashboard} />
                        <Route exact path="/workflow/categories" component={() => <Categories />} />
                        <Route path="/notauth" component={NotAuthorized} />
                        <Route exact path="/workflow/customfields" component={() => <CustomFieldPage />} />
                        <Route exact path="/workflow/locations" component={() => <Locations />} />
                        <Route exact path="/workflow/clients" component={() => <Clients />} />
                        <Route exact path="/workflow/clients/:id" exact component={Clients} />
                        <Route component={() => <Error404 />} />
                    </Switch>
                </ConnectedRouter>

                <Notify {...notifyDefaultProps} />

            </Fragment>
        );
    }
}

// function mapStateToProps(state) {
//   return {
//     notification: state.notification
//   };
// }

// export default connect(mapStateToProps, null)(App);

export default App;